import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { deleteTest } from "../../../Store/Thunk";
import { ConfirmDeleteButton } from "../../../../../SharedComponents/ListView";

export default function DeleteTestButton({ test }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const GetSchemeImageNames = () => {
    let imageNames = [];
    if (test.reportScheme?.adminWrapUpJson) {
      var scheme = JSON.parse(test.reportScheme?.adminWrapUpJson);
      scheme.forEach((item) => {
        if (item.componentName === "ImageSpace") return imageNames.push(item.imageName);
      });
    }

    return JSON.stringify(imageNames);
  };

  return (
    <ConfirmDeleteButton
      message={t("testDeleteHeading")}
      onConfirm={() => dispatch(deleteTest({ id: test.id, schemeImagesJson: GetSchemeImageNames() }))}
    />
  );
}
